export default __webpack_public_path__ + "static/media/favicon.6c1272a9.png";